// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3ULlg","inputWrap":"styles_inputWrap__3Hqp6","input":"styles_input__92pFw"};